














exports.default =
  components:
    list: require('./list')

  data: ->
    current_user: Session.current_user
    list_item_options:
      show_user: !Session.current_user.isSeller()




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/index.vue